import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { PhotoCredit } from '@components/PhotoCredit';
import { defaultBase64Placeholder } from '@components/CloudImage';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 420px;
  }
  .text-pairing-title {
    max-width: 350px;
  }
`;

export const StyledBackgroundImage = styled(Box)<{ isScrolledIntoView: boolean; backgroundImage: string }>`
  background: url(${({ isScrolledIntoView, backgroundImage }) =>
    isScrolledIntoView ? cloudAssetUrl(backgroundImage) : defaultBase64Placeholder});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: 820px;
  position: relative;
  background-position: 0% 60%;
  ${themeMediaQuery('xl')} {
    min-height: 1000px;
    background-position: 0% 70%;
  }
  ${themeMediaQuery('below_sm')} {
    background-position: 28%;
    min-height: 800px;
  }
`;

export const StyledTopWave = styled(CloudImage)`
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 2;
  margin-top: -2px;
`;

export const InvitesGalleryColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const InvitesGalleryBox = styled(Flex)`
  ${themeMediaQuery('sm')} {
    display: none;
  }
  position: absolute;
  bottom: -100px;
  z-index: 2;
  justify-content: center;
  width: 100%;
`;

export const InvitesGalleryImage = styled(CloudImage)`
  width: 445px;
  height: 357px;
  object-fit: contain;
  ${themeMediaQuery('below_sm')} {
    width: 310px;
    height: 250px;
  }
`;

export const StyledPhotoCredit = styled(PhotoCredit)`
  ${themeMediaQuery('below_sm')} {
    transform: rotate(90deg);
    bottom: 38px !important;
    right: -54px !important;
    & a > span {
      flex-direction: unset;
      div {
        margin-left: 0rem;
        margin-right: 0.5rem;
      }
    }
  }
`;
